import { render, staticRenderFns } from "./job-information.vue?vue&type=template&id=05dfbc56&scoped=true&"
import script from "./job-information.vue?vue&type=script&lang=js&"
export * from "./job-information.vue?vue&type=script&lang=js&"
import style0 from "./job-information.vue?vue&type=style&index=0&id=05dfbc56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dfbc56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
